const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
    },
    
    docName: {
         value: "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
    docDate: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
    docNpi: {
         value : "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
    docPhone: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CB1[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CB2[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis2[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CB3[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis3[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CB4[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis4[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CB5[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis5[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].OTHERDIAGNOSIS1[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis10[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].OTHERDIAGNOSIS2[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis11[0]",
        }    
    ]

}

export default ssn ;